const Plugin = {
  install(Vue) {
    if (this.installed) { return; }
    this.installed = true;
    this.lazyImgs = [];
    this.event = new Vue();

    this.isElementInViewPort = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        el.offsetParent !== null && //если элемент не скрыт
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );
    }

    this.check = (el) => {
      if (this.isElementInViewPort(el)) {
        el.dataset.src && (el.src = el.dataset.src);
        el.dataset.srcset && (el.srcset = el.dataset.srcset);
        this.lazyImgs = this.lazyImgs.filter((img) => img !== el);
      }
    }

    this._checkTimeout = null; 
    window.addEventListener('scroll', () => {
      clearTimeout(this._checkTimeout);
      this._checkTimeout = setTimeout(() => {
        this.lazyImgs.forEach(this.check);
      }, 100);
    });
  }
};

export default Plugin;